module.exports = __webpack_public_path__ + "static/img/5.9185180.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rarity/5.png
// module id = i12j
// module chunks = 0